import { Toaster as Sonner, toast } from 'sonner';
import { useTheme } from '../lib/theme';

/**
 * Transient confirmations only.
 *
 * A toast is the right shape for "revoked", "copied", "rated" — an outcome the
 * user just asked for and already expects. It is the wrong shape for anything
 * they must read to stay correct, which is why the key reveal is a modal and
 * why load failures render in place rather than floating away after four
 * seconds.
 */
export function Toaster() {
  const { resolvedTheme } = useTheme();

  return (
    <Sonner
      theme={resolvedTheme}
      position="bottom-right"
      // Sonner ships its own palette in its own stylesheet. Rather than
      // fighting it through the CSS variables it defines per theme, the
      // surfaces are restated as token-driven classes — one source of truth
      // for colour, and no second theme to keep in step with this one.
      toastOptions={{
        classNames: {
          toast:
            'font-sans text-sm rounded-lg border border-border bg-popover text-popover-foreground shadow-md',
          title: 'font-medium',
          description: 'text-muted-foreground',
          actionButton: 'bg-primary text-primary-foreground',
          cancelButton: 'bg-muted text-muted-foreground',
          error: 'border-destructive/40 [&_[data-icon]]:text-destructive',
          success: '[&_[data-icon]]:text-success',
          warning: '[&_[data-icon]]:text-warning',
          info: '[&_[data-icon]]:text-info',
        },
      }}
    />
  );
}

export { toast };
